"use client";

import { useEffect, type ReactNode } from "react";

import type { Locale } from "@/lib/i18n/config";
import { LocaleOverride, useLocale } from "@/lib/i18n/provider";

/** Force locale for locale-prefixed routes (SSR + client sync). */
export function LocaleGate({
  locale,
  children,
}: {
  locale: Locale;
  children: ReactNode;
}) {
  const { locale: current, setLocale } = useLocale();

  useEffect(() => {
    if (current !== locale) {
      setLocale(locale);
    }
  }, [current, locale, setLocale]);

  return <LocaleOverride locale={locale}>{children}</LocaleOverride>;
}
